import { Router } from '@angular/router'

export class UsersNavFacade {
    constructor(private router: Router) {}

    preferences() {
        this.router.navigate(['user-preferences'])
    }
}
